<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.1667 12.0843V9.57964C14.1667 9.43007 14.1667 9.35529 14.1439 9.28927C14.1238 9.23088 14.0909 9.1777 14.0477 9.13358C13.9988 9.08369 13.9319 9.05024 13.7981 8.98335L10 7.08428M3.33334 7.91762V13.5898C3.33334 13.8997 3.33334 14.0547 3.38169 14.1904C3.42443 14.3103 3.49409 14.4189 3.58532 14.5077C3.68852 14.6082 3.8294 14.6728 4.11113 14.8019L9.44447 17.2463C9.64883 17.34 9.75101 17.3868 9.85746 17.4053C9.95178 17.4217 10.0482 17.4217 10.1426 17.4053C10.249 17.3868 10.3512 17.34 10.5555 17.2463L15.8889 14.8019C16.1706 14.6728 16.3115 14.6082 16.4147 14.5077C16.5059 14.4189 16.5756 14.3103 16.6183 14.1904C16.6667 14.0547 16.6667 13.8997 16.6667 13.5898V7.91762M1.66667 7.08428L9.70186 3.06669C9.81118 3.01203 9.86584 2.9847 9.92317 2.97394C9.97395 2.96442 10.0261 2.96442 10.0768 2.97394C10.1342 2.9847 10.1888 3.01203 10.2981 3.06669L18.3333 7.08428L10.2981 11.1019C10.1888 11.1565 10.1342 11.1839 10.0768 11.1946C10.0261 11.2042 9.97395 11.2042 9.92317 11.1946C9.86584 11.1839 9.81118 11.1565 9.70186 11.1019L1.66667 7.08428Z"
      stroke="#EAF7F6"
      stroke-width="1.67"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
